export const FORECAST_FILTER_KEYS = {
  REVENUE_FORECAST: "revenueForecast",
  RENEWAL_COHORTS: "renewalCohorts",
  OPEN_OPPORTUNITIES: "openOpportunities",
  CLOSED_OPPORTUNITIES: "closedOpportunities",
};

export const ALL_COLUMN_KEYS = {
  // For per-type aggregated view (renewal forecast)
  OPP_TYPE: "oppType",
  ACCOUNTS: "accounts",
  CONTRACTS: "contracts",
  DELTA_MRR: "deltaMrr",
  DELTA_ARR: "deltaArr",

  // For per-account detailed view (pipeline evolution, renewed accounts)
  CONTRACT_NAME: "contractName",
  ACCOUNT_NAME: "accountName",
  CSM_NAME: "csmName",
  OPP_NAME: "oppName",
  STAGE: "stage",
  CLOSE_DATE: "closeDate",
  PCT_CHANGE: "pctChange",
  LOGO_LOST: "logoLost",
};

export const COMMON_COLUMNS_PER_ACCOUNT = [
  // ALL_COLUMN_KEYS.CONTRACT_NAME,
  ALL_COLUMN_KEYS.ACCOUNT_NAME,
  ALL_COLUMN_KEYS.CSM_NAME,
  ALL_COLUMN_KEYS.OPP_TYPE,
  ALL_COLUMN_KEYS.OPP_NAME,
  ALL_COLUMN_KEYS.CLOSE_DATE,
  ALL_COLUMN_KEYS.DELTA_MRR,
  ALL_COLUMN_KEYS.DELTA_ARR,
  ALL_COLUMN_KEYS.PCT_CHANGE,
];

export const FORECAST_FILTER_SPECIFIC_COLUMNS = {
  [FORECAST_FILTER_KEYS.REVENUE_FORECAST]: [
    ALL_COLUMN_KEYS.OPP_TYPE,
    ALL_COLUMN_KEYS.ACCOUNTS,
    ALL_COLUMN_KEYS.CONTRACTS,
    ALL_COLUMN_KEYS.DELTA_MRR,
    ALL_COLUMN_KEYS.DELTA_ARR,
  ],
  [FORECAST_FILTER_KEYS.RENEWAL_COHORTS]: [
    ALL_COLUMN_KEYS.OPP_TYPE,
    ALL_COLUMN_KEYS.ACCOUNTS,
    ALL_COLUMN_KEYS.CONTRACTS,
    ALL_COLUMN_KEYS.DELTA_MRR,
    ALL_COLUMN_KEYS.DELTA_ARR,
  ],
  [FORECAST_FILTER_KEYS.OPEN_OPPORTUNITIES]: [
    ...COMMON_COLUMNS_PER_ACCOUNT,
    ALL_COLUMN_KEYS.STAGE,
  ],
  [FORECAST_FILTER_KEYS.CLOSED_OPPORTUNITIES]: [
    ...COMMON_COLUMNS_PER_ACCOUNT,
    ALL_COLUMN_KEYS.LOGO_LOST,
  ],
};

export const COLUMN_TOOLTIPS = {
  [ALL_COLUMN_KEYS.DELTA_MRR]: {
    title: "Net Change in MRR",
    text: () => (
      <div>
        This is the net <strong>change</strong> in Monthly Recurring Revenue
        forecasted for each opportunity type. It will be positive for growth
        (like 'Renewal – Higher') and zero for 'Renewal – Flat'. The 'Total' row
        sums up all expected changes.
      </div>
    ),
  },
  [ALL_COLUMN_KEYS.DELTA_ARR]: {
    title: "Net Change in ARR",
    text: () => (
      <div>
        This is the net <strong>change</strong> in Annual Recurring Revenue
        forecasted for each opportunity type. It will be positive for growth
        (like 'Renewal – Higher') and zero for 'Renewal – Flat'. The 'Total' row
        sums up all expected changes.
      </div>
    ),
  },
};

// Legacy keys for backward compatibility with existing data fetching logic
export const LEGACY_FILTER_KEYS = {
  RENEWAL_FORECAST: "renewalForecast",
  PIPELINE_EVOLUTION: "pipelineEvolution",
  RENEWED_ACCOUNTS: "renewedAccounts",
};
